module.exports = __webpack_public_path__ + "static/media/check_icon.10d61a2e.svg";